import { Link } from "@inertiajs/react"
import React from "react"
import translate from "@/utils/translate"

export default function PageHeading({ data, bgSrc, variant }) {

    const isRTL = typeof document !== "undefined" && document.documentElement.dir === "rtl";

    return (
        <div
            className={`cs_page_heading cs_style_1 cs_bg_filed cs_primary_bg ${variant ? variant : ""}`}
            style={{ backgroundImage: `url(${bgSrc ?? ""})` }}
        >
            <div className="container">
                <div className="cs_section_heading cs_style_1">
                    
                    <ol className="breadcrumb cs_white_color d-flex flex-wrap align-items-center">
                        {data?.breadcrumb?.map((item, index) => {
                            const label = translate(item?.label ?? "Home")

                            return (
                                <li key={item?.url ?? index} className="d-flex align-items-center">
                                    
                                    {index === 0 && <i className="fas fa-home mx-2"></i>}

                                    {item?.url ? (
                                        <Link href={item.url} className="d-inline-flex align-items-center">
                                            {label}
                                        </Link>
                                    ) : (
                                        <span className="current-item">{label}</span>
                                    )}

                                    {index < data.breadcrumb.length - 1 && (
                                        <i className={`fas ${isRTL ? "fa-chevron-left" : "fa-chevron-right"} mx-2`}></i>
                                    )}
                                </li>
                            )
                        })}
                    </ol>

                </div>
            </div>
        </div>
    )
}